// extracted by mini-css-extract-plugin
export var completionBody = "_l7-2";
export var completionCard = "_l7-0";
export var completionFooter = "_l7-3";
export var completionTitle = "_l7-1";